<template>
    <div class="container">
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img class="img" :src="item">
            <button v-if="index == 1 || index == 4 || index == 8 || index == 10" class="btn-img" @click="JumpFn(index)"></button>
            <div class="activityImg" v-if="activity.isShow && index == 0">
                <img :src="activity.H5activeImg">
            </div>
        </div>
        <button class="footer" @click="JumpFn('footer')">
            <img :src="footer">
        </button>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import List from './list'
import activity from '../../../common/activity';
export default {
    data() {
        return {
            activity,
            List,
            imgList:[],
            footer:"",
        }
    },
    mounted () {
        setTimeout(()=>{
            this.eduPlatTrack('WebView', { page_id: 'e1sbs'});
        },500)
        let dataList = this.List.data.h5
        this.imgList = dataList.imgList
        this.footer = dataList.footer
    },
    methods: {
        JumpFn(index) {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': 'e1sbs',
                'button_name': '领取详细课程大纲'
            });
            let url = 'https://kaiwu.lagou.com/qrPage/5ac5c6ef6fe24c1ba30d9143acc8517a.html?wxInfo=2'
            let key = "https://t.lagou.com/FRDDRhRjcoA6A";
            if(index == 1 || index == 'footer') {
                location.href = key
            } else {
                location.href = url
            }
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%; 
    background-color: #ECF4FF;
    padding-bottom: 240px;
    .section {
        position: relative;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
        .btn-img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color:transparent;
            border: none;
        }
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        img {
            width: 100%;
            display: block;
        }
    }
}
</style>